// URX Embeded Form
// https://github.ibm.com/dgc-web-platform/widget-form

/*
* @todo: Check why it is fetching from stage
https://wwwstage.ibm.com/account/apis/v2.0/forms/formatted/MAIL-qtemaas360/en
https://www.ibm.com/account/apis/v2.0/forms/formatted/MAIL-qtemaas360/en
*/
// Must be the div id where you want the form to be loaded
export const INSTANCE_ID = 'urx-form';
// THE WRAPPER TO SCROLL TO
export const FORM_WRAPPER = 'urx-form__wrapper';
// The required urx form-id to be embedded
export const FORM_ID = 'QTE-securitymaas360';

// https://github.ibm.com/dgc-web-platform/widget-form
/*
 * @info: use
 * `$SME$ test`
 * for Company name to prevent creating official IBM CI
 */
export const FORM_ENV = 'production'; // stage, preview, production

// export const ENV = 'production'; //stage
// The required locale must be in the following format country code-language code
export const LOCALE = 'us-en';
